import {
  Box,
  Button,
  Fade,
  Grid,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import sendEvent from "../../utils/sendEvents";
import CommaSeprator from "../../components/CommaSeprator";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/system";
import InfoIcon from "@mui/icons-material/Info";
import useGetCompanyTypeData from "../../Hooks/CompanyData/useGetCompanyTypeData";
import useGetLoggedInUser from "../../Hooks/LoggedInUser/useGetLoggedInUser";
import useGetAuthUser from "../../Hooks/LoggedInUser/useGetAuthUser";
import GlobalToast from "../../components/Toasts/GlobalToast";

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} componentsProps={{ tooltip: { className: className } }} />
))(` background: #445fd2;
     width:auto;
      `);

const AdminReview = (props) => {
  const navigate = useNavigate();
  const { data: CompanyData } = useGetLoggedInUser();
  const draftdummy = CompanyData?.data?.CompanyAvatar?.url;
  const { data: AuthUserData } = useGetAuthUser();

  const { data: CompanyTypeData } = useGetCompanyTypeData(
    CompanyData?.data?.companyType
  );

  const NaviGateFunction = (product, view) => {
   
    if (
      AuthUserData?.data?.superAdmin ||
      AuthUserData?.data?.rightsarray?.SELLER?.includes?.("PRODUCTS_UPLOAD")
    ) {
      const { CompanyTypeName } = CompanyTypeData?.data || {};
      const {
        ListingType,
        ProductUploadStatus,
        VoucherType,
        reviewReasonNavigation,
        _id,
        ProductCategoryName,
      } = product;

      const baseUrl = "/home";
      let path = "";

      const isVoucher = ListingType === "Voucher";
      const isPendingApproval = ProductUploadStatus === "pendingapproval";
      const isApproved = ProductUploadStatus === "Approved";

      const voucherTypes = {
        "Offer Specific": "spacificvoucher",
        "Value Voucher / Gift Cards ": "Value Voucher / Gift Cards",
      };

      const companyTypeRoutes = {
        Textile: "textile",
        "Office Supply": "officesupply",
        Lifestyle: "lifestyle",
        Electronics: "electronics",
        FMCG: "fmcg",
        Mobility: "mobility",
        QSR: isVoucher ? "qsr" : "restaurant",
        Others: isVoucher ? "other" : "others",
        Hotel: "hotels",
        "Airlines Tickets": "airline",
        "Entertainment & Events": "ee",
      };

      const productInfoRoutes = {
        ProductInformation: "generalinformation",
        TechnicalInformation: "techinfo",
        GoLive: isVoucher ? "voucherdesign" : "golive",
      };

      if (isVoucher) {
        if (
          view &&
          isPendingApproval &&
          (VoucherType === "Value Voucher/Gift Cards " ||
            VoucherType === "Value Voucher / Gift Cards ")
        ) {
          path = `valueandgiftvoucher/${_id}`;
        } else if (
          view &&
          isPendingApproval &&
          VoucherType === "Offer Specific"
        ) {
          path = `${voucherTypes[VoucherType]}/${_id}`;
        } else if (companyTypeRoutes[CompanyTypeName]) {
          const companyRoute = companyTypeRoutes[CompanyTypeName];
          const infoRoute =
            productInfoRoutes[reviewReasonNavigation] || "generalinformation";
          if (reviewReasonNavigation === "GoLive") {
            path = `${companyRoute}Voucher/${infoRoute}/${_id}`;
          } else {
            path = `${companyRoute}Voucher/${companyRoute}${infoRoute}/${_id}`;
          }
        }
      } else {
        if ((view && isPendingApproval) || (view && isApproved)) {
          path = `allproductpreview/${_id}`;
        } else if (companyTypeRoutes[CompanyTypeName]) {
          const companyRoute = companyTypeRoutes[CompanyTypeName];
          const infoRoute =
            reviewReasonNavigation === "ProductInformation"
              ? "productinfo"
              : productInfoRoutes[reviewReasonNavigation] || "productinfo";
          path = `${companyRoute}/${companyRoute}${infoRoute}/${_id}`;
        }

        if (CompanyTypeName === "Media") {
          const mediaType =
            ProductCategoryName === "MediaOnline" ||
            ProductCategoryName === "Multiplex ADs"
              ? "online"
              : "offline";
          if (view) {
            path = `mediaonlineproductpreview/${_id}`;
          } else {
            const infoRoute =
              reviewReasonNavigation === "ProductInformation"
                ? "productinfo"
                : productInfoRoutes[reviewReasonNavigation] || "productinfo";
            path = `media${mediaType}/media${mediaType}${infoRoute}/${_id}`;
          }
        }
      }

      if (path) {
        navigate(`${baseUrl}/${path}`);
      }
    } else {
      return GlobalToast("You are not authorized to view products", "error");
    }
  };

  return (
    <Grid
      container
      sx={{
        mt: 2,
        height: "100%",
      }}
    >
      {props?.data?.map((res, idx) => {
        return (
          <>
            {props?.loader === true ? (
              <Paper
                onClick={() => {
                  sendEvent("Click on Review");
                }}
                sx={{
                  width: "100%",
                  height: "100%",
                  maxHeight: "100%",
                  position: "absolute",
                  top: 300,
                  left: 0,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "transparent",
                  zIndex: 1000,
                }}
                elevation={0}
              >
                <div className="triple-spinner"></div>
              </Paper>
            ) : (
              <Grid
                key={idx}
                item
                xl={3}
                lg={3}
                md={4}
                sm={6}
                xs={12}
                sx={{ mt: 3 }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    bgcolor: "transparent",
                    borderRadius: "15px",
                    maxWidth: "280px",
                    mx: "auto",
                  }}
                >
                  <Box
                    sx={{
                      boxSizing: "border-box",
                      width: {
                        xl: "100%",
                        lg: "99%",
                        md: "98%",
                        sm: "97%",
                        xs: "96%",
                      },
                      height: "auto",
                      minHeight: "280px",
                      bgcolor: "#fff",
                      borderRadius: "13.6px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      border: "0.1px solid transparent",
                      backgroundImage:
                        "linear-gradient(180deg,#C64091 0%,#C64091 47.4%,#C64091 100%)",
                      transition: "box-shadow .1s",
                      "&:hover": {
                        boxShadow: "0px 0px 17px #ff864547",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        mx: "auto",
                        height: "auto",
                        minHeight: "270px",
                        bgcolor: "#fff",
                        borderRadius: "13px",
                        padding: "5px",
                        cursor: "pointer",
                      }}
                    >
                      {res?.reviewReason === null ||
                      res?.reviewReason === undefined ? (
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-end",
                            minWidth: "250px",
                            backgroundColor: "white",
                            pointerEvents: "none",
                          }}
                        >
                          <CustomTooltip
                            sx={{ backgroundColor: "white" }}
                            TransitionComponent={Fade}
                            TransitionProps={{ timeout: 400 }}
                          >
                            <InfoIcon
                              sx={{
                                width: "28px",
                                height: "auto",
                                cursor: "pointer",
                                color: "white",
                              }}
                            />
                          </CustomTooltip>
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-end",
                            minWidth: "250px",
                          }}
                        >
                          <CustomTooltip
                            sx={{ backgroundColor: "red" }}
                            title={
                              <Typography sx={ToolTextStyle}>
                                {res?.reviewReason}
                              </Typography>
                            }
                            TransitionComponent={Fade}
                            TransitionProps={{ timeout: 400 }}
                          >
                            <InfoIcon
                              sx={{
                                width: "28px",
                                height: "auto",
                                cursor: "pointer",
                                color: "red",
                              }}
                            />
                          </CustomTooltip>
                        </Box>
                      )}

                      <Box
                        sx={{
                          width: "90%",
                          height: "auto",
                          minHeight: "160px",
                          maxHeight: "160px",
                          mx: "auto",
                          pt: 2,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={
                            res?.ProductImages?.at(0)?.url === null ||
                            res?.ProductImages?.at(0)?.url === undefined
                              ? res?.VoucherImages?.at(0)?.url || draftdummy
                              : res?.ProductImages?.at(0)?.url || draftdummy
                          }
                          alt="img"
                          style={{
                            width: "auto",
                            maxWidth: "230px",
                            maxHeight: "130px",
                            height: "auto",
                            marginLeft: "auto",
                            marginRight: "auto",
                            borderRadius: "10px",
                          }}
                        />
                      </Box>
                      <Box
                        sx={{
                          width: "100%",
                          maxWidth: "270px",
                          mx: "auto",
                          height: "auto",
                          display: "grid",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Paper
                          sx={{
                            width: "90%",
                            mx: "auto",
                            height: "auto",
                            minWidth: "240px",
                            maxWidth: "275px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignContent: "center",
                          }}
                          elevation={0}
                        >
                          <Typography
                            sx={{
                              ...MainTextStyle,
                              display: "-webkit-box",
                              WebkitLineClamp: 1,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {res?.ProductName}
                          </Typography>
                          <Typography
                            sx={{
                              ...PriceTextStyle,
                              display: "flex",
                              gap: "5px",
                              alignItems: "center",
                              alignContent: "center",
                            }}
                          >
                            <img
                              src="https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/BXITokenIcon.png"
                              alt="Icon"
                              style={{
                                width: "18px",
                                height: "18px",
                                marginRight: "0.5rem",
                              }}
                            />
                            <CommaSeprator
                              Price={
                                res?.ProductsVariantions?.at(0)?.DiscountedPrice
                                  ? res?.ProductsVariantions?.at(0)
                                      ?.DiscountedPrice
                                  : res?.ProductsVariantions?.at(0)
                                      ?.PricePerUnit
                              }
                            />
                          </Typography>
                        </Paper>
                        <Paper
                          sx={{
                            width: "90%",
                            height: "auto",
                            mx: "auto",
                            minWidth: "240px",
                            maxWidth: "275px",
                          }}
                          elevation={0}
                        >
                          <Typography sx={BottomTextStyle}>
                            {res?.ProductDescription}
                          </Typography>

                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            {res?.reviewReason ? (
                              <Button
                                sx={{
                                  width: "305px",
                                  textTransform: "none",
                                  mx: "auto",
                                  color: "#6B7A99",
                                  fontFamily: "Poppins",
                                  fontSize: "17px",
                                  fontWeight: 600,
                                }}
                                onClick={() => {
                                  NaviGateFunction(res, false);
                                }}
                              >
                                Edit
                              </Button>
                            ) : (
                              <Button
                                sx={{
                                  width: "305px",
                                  textTransform: "none",
                                  mx: "auto",
                                  color: "#6B7A99",
                                  fontFamily: "Poppins",
                                  fontSize: "17px",
                                  fontWeight: 600,
                                }}
                                onClick={() => {
                                  NaviGateFunction(res, true);
                                }}
                              >
                                View
                              </Button>
                            )}
                          </Box>
                        </Paper>
                      </Box>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
            )}
          </>
        );
      })}
    </Grid>
  );
};

export default AdminReview;

const MainTextStyle = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: { xl: "16px", lg: "16px", md: "14px", sm: "12px", xs: "12px" },
  lineHeight: "30px",
  width: "100%",
  color: "#141414",
  maxWidth: "160px",
  display: "-webkit-box",
  WebkitLineClamp: 1,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const PriceTextStyle = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: { xl: "14px", lg: "14px", md: "13px", sm: "13px", xs: "13px" },
  lineHeight: "24px",
  color: "#717171",
};

const BottomTextStyle = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "11px",
  lineHeight: "16px",
  color: "#6B7A99",
  textAlign: "left",
  mt: 1,
  display: "-webkit-box",
  WebkitLineClamp: 1,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const ToolTextStyle = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "10px",
  lineHeight: "13px",
  color: "#fff",
  textAlign: "center",
  cursor: "pointer",
  bgcolor: "red",
};
